import { define } from 'wicked-elements'

define('[data-component~="navigation-desktop"]', {
  init() {
    this.$upperNavigation = this.element.querySelector('#upper-navigation')
    this.$lowerNavigation = this.element.querySelector('#lower-navigation')
    this.$sections = this.element.querySelectorAll('.menu-section')
    this.$toggles = this.element.querySelectorAll('[data-toggle]')
    this.handleToggleClick = this.handleToggleClick.bind(this)
    this.handleOutsideClick = this.handleOutsideClick.bind(this)
    this.handleNavigateBack = this.handleNavigateBack.bind(this)
    this.handleElementLeave = this.handleElementLeave.bind(this)
  },
  connected() {
    // Toggle individual nav on toggle click
    this.$toggles.forEach(($toggle) => {
      $toggle.addEventListener('click', this.handleToggleClick)
    })

    // When clicking outside of an active nav element, close the nav
    this.element.addEventListener('click', this.handleOutsideClick)

    // When upper navigation leaves the viewport, close the nav
    this.observerInstance = new IntersectionObserver(this.handleElementLeave)
    this.observerInstance.observe(this.$upperNavigation)

    // When navigating back (in Safari), close the nav
    window.addEventListener('pageshow', this.handleNavigateBack)
  },
  disconnected() {
    // Teardown all listeners
    this.$toggles.forEach(($toggle) => {
      $toggle.removeEventListener('click', this.handleToggleClick)
    })
    this.element.removeEventListener('click', this.handleOutsideClick)
    window.removeEventListener('pageshow', this.handleNavigateBack)
    this.observerInstance.unobserve(this.$upperNavigation)
    this.observerInstance.disconnect()
  },
  handleToggleClick(event) {
    if (event.target.getAttribute('aria-expanded') === 'true') {
      this.closeSection(event.target.parentNode)
    } else {
      this.openSection(event.target.parentNode)
    }
  },
  handleOutsideClick(event) {
    const parentGroup = event.target.closest('.section-active')
    if (parentGroup) {
      this.closeSiblings(parentGroup)
    } else {
      this.closeAll()
    }
  },
  handleNavigateBack(event) {
    if (event.persisted) {
      this.closeAll()
    }
  },
  handleElementLeave(entries) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        this.closeAll()
      }
    })
  },
  closeAll() {
    this.$sections.forEach(($section) => this.closeSection($section))
    this.$lowerNavigation.classList.remove('is-open')
  },
  closeSiblings($target) {
    this.$sections.forEach(($section) => {
      if ($section !== $target) {
        this.closeSection($section)
      }
    })
  },
  openSection($section) {
    $section.classList.add('section-active')
    $section.firstElementChild.setAttribute('aria-expanded', 'true')
    $section.lastElementChild.setAttribute('aria-hidden', 'false')
    this.$lowerNavigation.classList.add('is-open')
  },
  closeSection($section) {
    $section.classList.remove('section-active')
    $section.firstElementChild.setAttribute('aria-expanded', 'false')
    $section.lastElementChild.setAttribute('aria-hidden', 'true')
  },
})
